import axios from 'axios';
import {
  ERROR_BUSINESS_LANDING_DESCRIPTION,
  ERROR_BUSINESS_PAGE_CONTENT,
  ERROR_SME_BUSINESS_LANDING_DESCRIPTION,
  ERROR_SME_BUSINESS_PAGE_CONTENT,
  LOADING_BUSINESS_LANDING_DESCRIPTION,
  LOADING_BUSINESS_PAGE_CONTENT,
  LOADING_SME_BUSINESS_LANDING_DESCRIPTION,
  LOADING_SME_BUSINESS_PAGE_CONTENT,
  SUCCESS_BUSINESS_LANDING_DESCRIPTION,
  SUCCESS_BUSINESS_PAGE_CONTENT,
  SUCCESS_SME_BUSINESS_LANDING_DESCRIPTION,
  SUCCESS_SME_BUSINESS_PAGE_CONTENT,
} from '../../const/actionTypes';

export const getBusinessLandingPageDescription = () => (dispatch: any) => {
  dispatchAction(dispatch, LOADING_BUSINESS_LANDING_DESCRIPTION);
  axios
    .get('https://slt.lk/business-landing-description')
    .then((res) => {
      dispatchAction(dispatch, SUCCESS_BUSINESS_LANDING_DESCRIPTION, res.data);
    })
    .catch(() => {
      dispatchAction(dispatch, ERROR_BUSINESS_LANDING_DESCRIPTION);
    });
};

export const getBusinessLandingPageContent = () => (dispatch: any) => {
  dispatchAction(dispatch, LOADING_BUSINESS_PAGE_CONTENT);
  axios
    .get('https://slt.lk/api-business')
    .then((res) => {
      dispatchAction(dispatch, SUCCESS_BUSINESS_PAGE_CONTENT, res.data);
    })
    .catch(() => {
      dispatchAction(dispatch, ERROR_BUSINESS_PAGE_CONTENT);
    });
};

export const getSmeBusinessLandingDescription = () => (dispatch: any) => {
  dispatchAction(dispatch, LOADING_SME_BUSINESS_LANDING_DESCRIPTION);
  axios
    .get('https://slt.lk/sme-business-landing-description')
    .then((res) => {
      dispatchAction(
        dispatch,
        SUCCESS_SME_BUSINESS_LANDING_DESCRIPTION,
        res.data
      );
    })
    .catch(() => {
      dispatchAction(dispatch, ERROR_SME_BUSINESS_LANDING_DESCRIPTION);
    });
};

export const getSmeBusinessPageContent = () => (dispatch: any) => {
  dispatchAction(dispatch, LOADING_SME_BUSINESS_PAGE_CONTENT);
  axios
    .get('https://slt.lk/api-micro-musiness')
    .then((res) => {
      dispatchAction(dispatch, SUCCESS_SME_BUSINESS_PAGE_CONTENT, res.data);
    })
    .catch(() => {
      dispatchAction(dispatch, ERROR_SME_BUSINESS_PAGE_CONTENT);
    });
};

const dispatchAction = (dispatch: any, type: string, payload?: any) => {
  dispatch({
    type: type,
    payload: payload,
  });
};
